import React from "react";
import './App.css';
import CareerPathwaysPortal from './CareerPathwaysPortal';
import { loadConfig } from './config';
import Chatbot from './components/Chatbot';
import FeedbackPopup from './components/FeedbackPopup';
import ScrollToTop from './components/ScrollToTop';
import { TooltipProvider } from './contexts/TooltipContext';

function App() {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-gray-50">
        {/* Main Career Portal Component */}
        <CareerPathwaysPortal />
        
        {/* Chatbot Component - Fixed Position Bottom Left         */}

        <Chatbot /> 
        {/* Feedback Popup - Appears after 3 minutes */}
        <FeedbackPopup />
        
        {/* Scroll to Top - Professional style */}
        <ScrollToTop />
      </div>
    </TooltipProvider>
  );
}

export default App;
